import ApiService from '@/services/core/api.service'

const AdminDashboardService = {
  async getStatistics () {
    return ApiService.get('admin/dashboard/statistics')
  }
}

export default AdminDashboardService
